"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WARRANCY_TEXT = exports.MIR_TOOLTIP = exports.CARD_FIELDS = void 0;
var _localization = require("@lt/localization");
var WARRANCY_TEXT = exports.WARRANCY_TEXT = _localization.i18n.t('checkout.payment.warrancy');
var MIR_TOOLTIP = exports.MIR_TOOLTIP = _localization.i18n.t('checkout.payment.mir');
var CARD_FIELDS = exports.CARD_FIELDS = {
  NUMBER: {
    id: 'pan',
    name: 'pan',
    placeholder: '0000 0000 0000 0000',
    autocomplete: 'cc-number',
    maxLength: 22
  },
  EXP_DATE: {
    id: 'expDate',
    name: 'expDate',
    placeholder: '00/00',
    autocomplete: 'cc-exp',
    maxLength: 5
  },
  CVV: {
    id: 'cvv',
    name: 'cvv',
    placeholder: '000',
    autocomplete: 'cc-csc',
    maxLength: 3
  }
};